/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Client, RequestContext } from "../client";
import type { InterruptionResource } from "../resources/interruptionResource";
import type { ListArgs } from "./basicRepository";
import { BasicRepository } from "./basicRepository";
type InterruptionListArgs = {
    regarding?: string;
    pendingOnly?: boolean;
} & ListArgs;
export class InterruptionRepository extends BasicRepository<InterruptionResource, InterruptionResource, InterruptionListArgs> {
    constructor(client: Client, requestContext: RequestContext) {
        super("Interruptions", client, requestContext);
    }
    submit(interruption: InterruptionResource, result: any) {
        return this.client.post(this.requestContext, interruption.Links["Submit"], result);
    }
    takeResponsibility(interruption: InterruptionResource) {
        return this.client.put(this.requestContext, interruption.Links["Responsible"]);
    }
}
